export { default } from "./getChallengesBreadcrumbsLinks";
